import { Box } from '@chakra-ui/react';
import { ContainerProps, Group, Icon, IconKey, SectionBannerProps, Typography } from '@melio/penny';

type OmittedProps = 'onClose' | 'showCloseButton' | 'icon' | 'variant' | 'description';

export type FullSectionBannerVariant = 'info';

type FullSectionBannerProps = Omit<SectionBannerProps, OmittedProps> & {
  variant: FullSectionBannerVariant;
  title: string;
  description: string;
};

type VariantValues = {
  icon: IconKey;
  backgroundColor: ContainerProps['backgroundColor'];
};

const variantsMap: Record<FullSectionBannerVariant, VariantValues> = {
  info: {
    icon: 'info',
    backgroundColor: 'light',
  },
};

export const FullSectionBanner = ({
  variant = 'info',
  title,
  description,
  showIcon = true,
}: FullSectionBannerProps) => {
  const { icon } = variantsMap[variant];

  return (
    <Box
      backgroundColor="info.lightest"
      border="none"
      paddingX="s"
      paddingY="s"
      borderRadius="l"
      display="flex"
      p="s"
      gridGap="s"
      justifyContent="space-between"
      width="full"
      height="auto"
    >
      <Group spacing="s">
        {showIcon && <Icon type={icon} size="small" />}
        <Box display="flex" flexDirection="column" justifyContent="center" flex="1" wordBreak="break-word">
          {title && <Typography.Label label={title} />}
          {description && <Typography.Description label={description} />}
        </Box>
      </Group>
    </Box>
  );
};
